import { Pencil } from 'react-bootstrap-icons';
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { IItem } from "../../api/types";
import { ItemForm } from './ItemForm';
import { useState } from 'react';

export const EditButton = (props: { item: IItem, update: (updates: Partial<IItem>) => void }) => {
  const [open, setOpen] = useState(false)

  return <>
    <OverlayTrigger overlay={<Tooltip>Edit Item</Tooltip>}>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setOpen(true)}>
        <Pencil />
      </Button>
    </OverlayTrigger>
    <Modal show={open} onHide={() => setOpen(false)}>
      <ItemForm onClose={() => setOpen(false)} onSave={props.update} item={props.item}/>
    </Modal>
  </>
}